import React from 'react';
import PropTypes from 'prop-types';
import Navbar from '../../components/Navbar';
import Header from '../../components/Header';

const Unknown = ({ message }) => (
  <>
    <Navbar />
    <Header />
    <h1 className="text-center mb-2 font-32">{message}</h1>
  </>
);

Unknown.propTypes = {
  message: PropTypes.string,
};

Unknown.defaultProps = {
  message: '',
};

export default Unknown;
